"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _deepEqual = _interopRequireDefault(require("deep-equal"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

/** *
 * this class makes these assumptions:
 *
 * 1) the render should depend on a version of the props that is extrapolated into state.
 * 2) it's more efficient to have a componentShouldUpdate even if componentDidUpdate forces a second pass.
 *
 */
var PropsToStateComponent = /*#__PURE__*/function (_Component) {
  _inheritsLoose(PropsToStateComponent, _Component);

  function PropsToStateComponent(props) {
    var _this;

    _this = _Component.call(this, props) || this;
    _this.state = _this.propsToState(props);
    return _this;
  }

  var _proto = PropsToStateComponent.prototype;

  _proto.propsToState = function propsToState(pProps) {
    var props = pProps || this.props;
    return _extends({}, props);
  };

  _proto.shouldComponentUpdate = function shouldComponentUpdate(newProps, newState) {
    return !(0, _deepEqual["default"])(this.state, newState) || !(0, _deepEqual["default"])(newState, this.propsToState(newProps)); // not sure about part 2
  };

  _proto.componentDidUpdate = function componentDidUpdate() {
    if (!(0, _deepEqual["default"])(this.state, this.propsToState())) {
      this.setState(this.propsToState());
    }
  };

  _proto.render = function render() {
    console.log('override PTSC render: ', this.state, this);

    try {
      return /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("pre", null, JSON.stringify(this.state)));
    } catch (err) {
      try {
        return /*#__PURE__*/_react["default"].createElement("div", null, this.state);
      } catch (err2) {
        return /*#__PURE__*/_react["default"].createElement("div", null, "PTSC with un-renderable state");
      }
    }
  };

  return PropsToStateComponent;
}(_react.Component);

exports["default"] = PropsToStateComponent;